export interface ReportBodyStyle {
  fontFamily: string;
  fontSize: string;
  textColor: string;
}

export interface ReportHeaderStyle {
  backgroundColor: string;
  titleFontSize: string;
  subtitleFontSize: string;
}

export interface ReportLineSectionStyle {
  borderColor: string;
  headerBackground: string;
  headerFontSize: string;
}

export interface ReportTableHeaderStyle {
  backgroundColor: string;
  fontSize: string;
  borderColor: string;
}

export interface ReportTableCellStyle {
  fontSize: string;
  borderColor: string;
  machineNumberBg: string;
  dayCellBg: string;
  nightCellBg: string;
  totalCellBg: string;
  lowEfficiencyColor: string;
}

export interface ReportSummaryStyle {
  borderColor: string;
  titleBackground: string;
  titleFontSize: string;
  contentFontSize: string;
  valueFontSize: string;
}

export interface StopRowColorEntry {
  minHours: number;
  color: string;
  label: string;
}

export interface ReportColumnConfig {
  key: string;
  label: string;
  visible: boolean;
}

export interface ReportStyleConfig {
  body: ReportBodyStyle;
  header: ReportHeaderStyle;
  lineSection: ReportLineSectionStyle;
  tableHeader: ReportTableHeaderStyle;
  tableCells: ReportTableCellStyle;
  summary: ReportSummaryStyle;
  stopRowColors: StopRowColorEntry[];
  visibleColumns: ReportColumnConfig[];
}

export const DEFAULT_REPORT_STYLE_CONFIG: ReportStyleConfig = {
  body: {
    fontFamily: "'Arial', sans-serif",
    fontSize: '7.5px',
    textColor: '#1a202c',
  },
  header: {
    backgroundColor: '#1a202c',
    titleFontSize: '12px',
    subtitleFontSize: '8px',
  },
  lineSection: {
    borderColor: '#cbd5e0',
    headerBackground: '#edf2f7',
    headerFontSize: '8.5px',
  },
  tableHeader: {
    backgroundColor: '#4a5568',
    fontSize: '6.5px',
    borderColor: '#cbd5e0',
  },
  tableCells: {
    fontSize: '7.5px',
    borderColor: '#e2e8f0',
    machineNumberBg: '#f7fafc',
    dayCellBg: '#ebf8ff',
    nightCellBg: '#faf5ff',
    totalCellBg: '#fffaf0',
    lowEfficiencyColor: '#e53e3e',
  },
  summary: {
    borderColor: '#1a202c',
    titleBackground: '#1a202c',
    titleFontSize: '9px',
    contentFontSize: '8px',
    valueFontSize: '9px',
  },
  stopRowColors: [
    { minHours: 4, color: '#3B82F6', label: '4+ hours' },
    { minHours: 3, color: '#FACC15', label: '3-4 hours' },
    { minHours: 2, color: '#EF4444', label: '2-3 hours' },
    { minHours: 1, color: '#EC4899', label: '1-2 hours' },
  ],
  visibleColumns: [
    { key: 'machineNo', label: 'Machine #', visible: true },
    { key: 'rpm', label: 'RPM', visible: true },
    { key: 'pick', label: 'Pick', visible: true },
    { key: 'dayMeter', label: 'Day Meter', visible: true },
    { key: 'dayEff', label: 'Day Eff%', visible: true },
    { key: 'nightMeter', label: 'Night Meter', visible: true },
    { key: 'nightEff', label: 'Night Eff%', visible: true },
    { key: 'totalMeter', label: 'Total Meter', visible: true },
    { key: 'totalEff', label: 'Total Eff%', visible: true },
    { key: 'stopCount', label: 'Stops', visible: true },
    { key: 'runTime', label: 'Run Time', visible: true },
    { key: 'stopTime', label: 'Stop Time', visible: true },
    // No-signal time (chip sent no logs). Key must match backend DEFAULT_REPORT_STYLE_CONFIG.
    { key: 'offlineTime', label: 'Offline', visible: true },
  ],
};
